import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OmniConversationSummaryCard } from '@cigna/omni/conversation-summary-card';
import { timer } from 'rxjs';
import {
  bufferCount,
  concat,
  concatMap,
  scan,
  take,
  map,
} from 'rxjs/operators';
import { ConvSummaryListFacade } from '../+state/omni-conversation-summary-list.facade';

@Component({
  selector: 'cigna-omni-conversation-summary-list',
  templateUrl: './omni-conversation-summary-list.component.html',
  styleUrls: ['./omni-conversation-summary-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmniConversationSummaryListComponent {
  private loadOneListItemAtATime$ = this.facade.sortedSummaryCardItems$.pipe(
    take(1),
    concatMap((data) => data),
    bufferCount(3),
    concatMap((data) => timer().pipe(map(() => data))),
    scan<OmniConversationSummaryCard[], OmniConversationSummaryCard[]>(
      (acc, val) => [...acc, ...val],
      [],
    ),
  );

  private loadAllListItemsAtOnce$ = this.facade.sortedSummaryCardItems$;

  public summaryCardList$ = this.loadOneListItemAtATime$.pipe(
    concat(this.loadAllListItemsAtOnce$),
  );

  public trackByFunc(index: number, item: OmniConversationSummaryCard): string {
    return item.conversationId;
  }

  constructor(public facade: ConvSummaryListFacade) {}
}
